import http from '@/utils/http';
import i18n from '@/main';

export default {
    buscarAgricola(geometria) {
        return http.post({
            url: '/historico/agricola',
            lockScreen: true,
            data: { geometria },
            lockMessage: i18n.t('mensagens.sistema.buscandoHistoricoAgricola')
        });
    },

    buscarHistoricoMonitoramentoPorAreaMonitoradaId(
        idAreaMonitorada,
        somenteAlertas = false
    ) {
        return http.get({
            url: `/historico/${idAreaMonitorada}?somenteAlertas=${somenteAlertas}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoHistoricoMonitoramento')
        });
    }
};
